import React, { useContext } from 'react';
import { css } from '@emotion/react';

import { handheld } from 'styles/global_defaults/media-queries';

// components
import BackToCourseOutlineButton from './actions/back-to-course-outline-button';
import DuplicateLecturePageButton from './actions/duplicate-lecture-page-button';
import AddNewLessonButton from './actions/add-new-lesson-button';
import AddToCollectionButton from './actions/add-to-collection-button';
import DeleteLessonButton from './actions/delete-lesson-button';
import ExitButton from './actions/exit-button';
import MoreMenuActionButton from './actions/more-menu-action-button';

type EditMenuRightPanelProps = {
  onExitClick: () => void;
};

export const EditMenuRightPanel = ({ onExitClick }: EditMenuRightPanelProps) => {
  const styles = css`
    &.edit-menu-right-panel {
      .edit-menu-more {
        display: none; // hidden by default
      }

      ${handheld(css`
        .edit-menu-actions {
          display: none !important; // hide icon buttons
        }

        .edit-menu-more {
          display: flex !important; // show More dropdown
        }
      `)};
    }
  `;

  return (
    <div css={styles} className='edit-menu-right-panel d-flex align-items-center'>
      <div className='edit-menu-actions d-flex align-items-center'>
        <BackToCourseOutlineButton />
        <DuplicateLecturePageButton />
        <AddNewLessonButton />
        <AddToCollectionButton />
        <DeleteLessonButton />
      </div>

      <div className='edit-menu-more'>
        <MoreMenuActionButton />
      </div>

      <ExitButton onClick={onExitClick} />
    </div>
  );
};

export default EditMenuRightPanel;
